import { Root } from './Root/Root'
import { Header } from './Header/Header'
import { Content } from './Content/Content'
import { Section } from './Section/Section'
import { Subtitle } from './Subtitle/Subtitle'
import { Title } from './Title/Title'
import { ButtonFooter } from './ButtonFooter/ButtonFooter'

export const MobileWizard = {
  Root,
  Header,
  Content,
  Section,
  Title,
  Subtitle,
  ButtonFooter,
}
